import React, { useEffect, useMemo, useState } from 'react';
import { resolveHostPhotoUrl } from '../../utils/hostPhotoUrl';

const getHostInitials = (venue) => {
  const name = venue?.contact_name || venue?.contactName || venue?.name || '';
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase();
  }
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return 'H';
};

const VenueHostInfo = ({ venue }) => {
  const hostName = venue.contact_name || venue.contactName || venue.name;
  const configured = useMemo(() => resolveHostPhotoUrl(venue), [venue]);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    setImageError(false);
  }, [configured]);

  const showPhoto = configured && !imageError;
  const initials = getHostInitials(venue);

  return (
    <div className="vd-host-card flex flex-col gap-4 md:flex-row items-center justify-between mb-8">
      <div className="flex flex-col md:flex-row items-start md:items-center gap-6 w-full">
        <div className="relative rounded-full shrink-0 w-16 h-16 overflow-hidden border-2 border-[#ebe4dc] bg-white shadow-sm">
          {showPhoto ? (
            <img
              src={configured}
              alt=""
              className="w-full h-full object-cover"
              onError={() => setImageError(true)}
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-[#FFF5F0] to-[#FFEEE5] text-[#046242] font-semibold text-xl">
              {initials}
            </div>
          )}
        </div>

        <div className="flex flex-col gap-1 items-start ">
          <p className="vd-host-name whitespace-nowrap">
            Hosted by {hostName}
          </p>
        </div>
      </div>
    </div>
  );
};

export default VenueHostInfo;
